// extracted by mini-css-extract-plugin
var _1 = "Divider-moduleDivider__dL3Vg";
var _2 = "Divider-moduleround__NGMly";
export { _1 as "Divider", _2 as "round" }
